module.exports = __webpack_public_path__ + "img/wind-warning.95df7f1d.svg";